'use client';

import type { PropsWithChildren } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import type { AnimatedIconProps, AnimatedPanelIndicatorProps } from './types';

/**
 * @description Skeleton component for animated panel toggles
 */
export const PanelBase = ({
  children,
  ...props
}: PropsWithChildren<AnimatedIconProps>) => (
  <svg
    fill="currentColor"
    height="100%"
    viewBox="0 0 24 24"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M4 6.75A2.75 2.75 0 0 1 6.75 4h10.5A2.75 2.75 0 0 1 20 6.75v10.5A2.75 2.75 0 0 1 17.25 20H6.75A2.75 2.75 0 0 1 4 17.25V6.75ZM6.75 5.5c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25V6.75c0-.69-.56-1.25-1.25-1.25H6.75Z"
      fillRule="evenodd"
    />
    {children}
  </svg>
);

/**
 * @description Animated panel indicator that animates to expanded state when selected as visible or expanded
 */
export const PanelIndicator = ({
  $isSelected,
  variants,
  ...props
}: AnimatedPanelIndicatorProps) => (
  <AnimatePresence initial={false}>
    <motion.rect
      animate={$isSelected ? `expanded` : `collapsed`}
      exit="loading"
      initial="loading"
      rx="1"
      variants={variants}
      {...props}
    />
  </AnimatePresence>
);
